import React from 'react';
import { motion } from 'framer-motion';
import { Unlock, Cpu, BookOpen } from 'lucide-react';
export function Revelation() {
  return <section className="py-12 md:py-24 bg-zinc-900 px-4 relative overflow-hidden" data-id="element-132" data-mp="3t0l4jx3fcqoq">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-amber-900/20 via-zinc-900 to-zinc-900" data-id="element-133" data-mp="1syt3iagrjxb" />
      
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-134" data-mp="bjtpvglc61x0">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 md:mb-16" data-id="element-135" data-mp="bja7jyrrxbig">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-zinc-800 text-zinc-300 text-sm font-medium mb-6" data-id="element-136" data-mp="kl1aivuxj48m">
            <Unlock className="w-4 h-4" data-id="element-137" data-mp="2mbuwq1zfajpl" />
            LA VERDAD INCÓMODA
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-138" data-mp="2mdxtd4v2zb3a">
            La Publicidad Premium Nunca Fue Cuestión de Dinero. Fue Cuestión de Un <span className="text-amber-500" data-id="element-139" data-mp="3hit91az3uz7f">Protocolo</span> Que Nadie Te Enseñó
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-140" data-mp="3cpi2lay7gkg1">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-6" data-id="element-141" data-mp="37t006hqcky6v">
            <p className="text-xl text-zinc-300" data-id="element-142" data-mp="4a6pqdsv8pgx">
              Las agencias de 9 cifras no tienen cámaras mágicas ni diseñadores extraterrestres.
            </p>
            <div className="flex gap-4 items-start" data-id="element-143" data-mp="3rfxm8laz3kc3">
              <div className="w-12 h-12 rounded-full bg-amber-500/10 flex items-center justify-center shrink-0" data-id="element-144" data-mp="3remnx10ar4sd">
                <Cpu className="w-6 h-6 text-amber-500" data-id="element-145" data-mp="3mgl3ocr4wzfb" />
              </div>
              <div data-id="element-146" data-mp="2g1k4ly6tc14i">
                <h3 className="text-white font-bold text-lg mb-2" data-id="element-147" data-mp="2g23ohkg0wzl6">Tienen un sistema.</h3>
                <p className="text-zinc-400" data-id="element-148" data-mp="2b04jk64mxum4">Una secuencia exacta de instrucciones que convierte texto simple en piezas visuales que detienen el pulgar en menos de 3 segundos.</p>
              </div>
            </div>
            <div className="flex gap-4 items-start" data-id="element-149" data-mp="2hfv9ceh9pt7h">
              <div className="w-12 h-12 rounded-full bg-amber-500/10 flex items-center justify-center shrink-0" data-id="element-150" data-mp="23iy6fenvkla8">
                <BookOpen className="w-6 h-6 text-amber-500" data-id="element-151" data-mp="27igswevch4f6" />
              </div>
              <div data-id="element-152" data-mp="1ts3k6aamplos">
                <h3 className="text-white font-bold text-lg mb-2" data-id="element-153" data-mp="1trlhautgo97w">Nosotros lo desarmamos.</h3>
                <p className="text-zinc-400" data-id="element-154" data-mp="1yjve8uszu9jo">Simplificamos ese sistema y lo convertimos en un manual que cualquiera puede ejecutar hoy mismo.</p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="relative rounded-2xl overflow-hidden border border-zinc-800 aspect-[4/3] bg-zinc-950 flex items-center justify-center" data-id="element-155" data-mp="1ou2500gbq6il">
            <video autoPlay loop muted playsInline className="w-full h-full object-cover opacity-80" data-id="element-156" data-mp="w72dutcxuapz">
              <source src="https://cdn.magicpatterns.com/uploads/55KnTbRTivKPf69boyz6W6/labs-003.mp4" type="video/mp4" data-id="element-157" data-mp="1591wfq3lpmv1" />
            </video>
            <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-transparent to-transparent" data-id="element-158" data-mp="1f5ofqaga45uy" />
            <div className="absolute bottom-6 left-6 right-6 text-center" data-id="element-159" data-mp="1a6uyq81s9wq1">
              <h3 className="text-2xl font-bold text-white mb-2" data-id="element-160" data-mp="1a4qyc033ffui">Nano-Creative Bible</h3>
              <p className="text-amber-500 font-medium" data-id="element-161" data-mp="1oxkdtlid7vz6">El Protocolo de 9 Cifras</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}